import styled from 'styled-components'
import tw from 'tailwind.macro'

const StWrap = styled.div`
  display: grid;
  align-items: stretch;
  justify-content: center;
  ${tw`sm:p-8 p-4`};
`

const StStep = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export { StStep, StWrap }
